import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/app/client/src/app/(auth)/forgot-password/form.tsx");
